"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.codeSplit = exports.CodeSplit = void 0;
var tslib_1 = require("tslib");
/* eslint-disable max-classes-per-file */
var React = require("react");
var CodeSplit = /** @class */function (_super) {
  tslib_1.__extends(CodeSplit, _super);
  function CodeSplit(props) {
    return _super.call(this, props) || this;
  }
  CodeSplit.loadRoute = function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        throw new Error('loadRoute not implemented');
      });
    });
  };
  CodeSplit.componentLoaded = false;
  return CodeSplit;
}(React.Component);
exports.CodeSplit = CodeSplit;
/**
 * Gets the appropriate name of a code split component.
 *
 * @param WrappedComponent The internally loaded React component.
 */
var getDisplayName = function (WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
/**
 * Produces a new React component class that asynchronously loads the internal component.
 *
 * For use with dynamic imports. See more:
 * - Mozilla: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#Dynamic_Imports
 * - Webpack: https://webpack.js.org/guides/code-splitting/
 * --- or use commit hash b77b222c1c52873f7d8b2fb66573598ef4ad5232 instead of master
 *
 * @param {CodeSplitLoader} loaderFunction A function that returns a `Promise` containing an object with a default
 * export of a React component. Bernie is unable to know any specifics of the imported component, therefore it requires
 * a default export so it has something to run. It will throw an error if a default export is not found.
 */
var codeSplit = function (loaderFunction) {
  return /** @class */function (_super) {
    tslib_1.__extends(WebpackRoute, _super);
    function WebpackRoute(props) {
      var _this = _super.call(this, props) || this;
      _this.logger = {};
      _this.state = {
        component: WebpackRoute.wrappedComponent
      };
      if (!_this.state.component) {
        _this.doLoadRoute(false);
      }
      return _this;
    }
    WebpackRoute.prototype.componentDidMount = function () {
      if (!this.state.component) {
        this.doLoadRoute();
      }
    };
    WebpackRoute.prototype.render = function () {
      var Component = this.state.component;
      var loadingComponent = this.props.loadingState || null;
      return Component ? React.createElement(Component, tslib_1.__assign({}, this.props)) : loadingComponent;
    };
    WebpackRoute.prototype.doLoadRoute = function () {
      return tslib_1.__awaiter(this, arguments, void 0, function (setState) {
        var component, error_1;
        if (setState === void 0) {
          setState = true;
        }
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);
              return [4 /*yield*/, WebpackRoute.loadRoute()];
            case 1:
              component = _a.sent();
              if (setState) {
                this.setState({
                  component: component
                });
              }
              return [3 /*break*/, 3];
            case 2:
              error_1 = _a.sent();
              if (this.logger && this.logger.error) {
                this.logger.error(error_1);
              }
              return [3 /*break*/, 3];
            case 3:
              return [2 /*return*/];
          }
        });
      });
    };
    WebpackRoute.loadRoute = function () {
      return tslib_1.__awaiter(this, void 0, void 0, function () {
        var component;
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!!WebpackRoute.componentLoaded) return [3 /*break*/, 2];
              return [4 /*yield*/, loaderFunction()];
            case 1:
              component = _a.sent();
              if (!component || !component.default) {
                throw new Error('Code split components must have a default export');
              }
              WebpackRoute.wrappedComponent = component.default;
              WebpackRoute.displayName = "WebpackRoute(".concat(getDisplayName(component.default), ")");
              WebpackRoute.componentLoaded = true;
              _a.label = 2;
            case 2:
              return [2 /*return*/, WebpackRoute.wrappedComponent];
          }
        });
      });
    };
    return WebpackRoute;
  }(CodeSplit);
};
exports.codeSplit = codeSplit;